import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import AuditTrailAPI from '../../api/wgpt/auditTrail';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  meta: {},
  appliedFilters: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  get: $state => $state.records,
  getMeta: $state => $state.meta,
  getUIFlags: $state => $state.uiFlags,
  getAppliedFilters: $state => $state.appliedFilters,
};

export const actions = {
  get: async ({ commit }, params) => {
    commit(types.SET_WGPT_AUDIT_TRAIL_UI_FLAG, { isFetching: true });
    try {
      const response = await AuditTrailAPI.filter(params);
      commit(types.SET_WGPT_AUDIT_TRAIL_META, response.data.meta);
      commit(types.SET_WGPT_AUDIT_TRAIL, response.data.payload);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_AUDIT_TRAIL_UI_FLAG, { isFetching: false });
    }
    return null;
  },
  clearFilters: ({ commit }) => {
    commit(types.SET_WGPT_AUDIT_TRAIL, []);
    commit(types.SET_WGPT_AUDIT_TRAIL_APPLIED_FILTERS, []);
  },
  setAppliedFilters: ({ commit }, filters) => {
    commit(types.SET_WGPT_AUDIT_TRAIL_APPLIED_FILTERS, filters);
  },
};

export const mutations = {
  [types.SET_WGPT_AUDIT_TRAIL_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_WGPT_AUDIT_TRAIL_META]($state, data) {
    $state.meta = data;
  },
  [types.SET_WGPT_AUDIT_TRAIL]: MutationHelpers.set,
  [types.SET_WGPT_AUDIT_TRAIL_APPLIED_FILTERS]($state, data) {
    $state.appliedFilters = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
